import {
  CubeReducerState,
  CubeStatus,
  DisabledReasonType,
  VisibleEnabledFeatureAvailable
} from 'modules/Cube/domain/cube.domain.types'

const editableDuringStatuses = [
  CubeStatus.ScheduleUnsaved,
  CubeStatus.ScheduleDraft,
  CubeStatus.SchedulePending,
  CubeStatus.ScheduleActive
]

export const getLabelAvailable = (
  prevState: CubeReducerState
): VisibleEnabledFeatureAvailable => {
  const visible = prevState.configuration.features.showLabelField
  if (!editableDuringStatuses.includes(prevState.data.common.status)) {
    return {
      available: {
        visible,
        enabled: false
      },
      reasons: [
        {
          reasonType: DisabledReasonType.InvalidStatus,
          metadata: {
            status: prevState.data.common.status
          }
        }
      ]
    }
  }

  return {
    available: {
      visible,
      enabled: true
    },
    reasons: []
  }
}
